'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagGbNirAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M28 0H0V20H28V0Z", fill: "white" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 8H0V12H12V20H16V12H28V8H16V0H12V8Z",
          fill: "#E82739"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M15.3553 12.3475L14 14.6667L12.6446 12.3475L9.95852 12.3333L11.2893 10L9.95852 7.66667L12.6446 7.65251L14 5.33333L15.3553 7.65251L18.0414 7.66667L16.7106 10L18.0414 12.3333L15.3553 12.3475Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.7342 9.34125C12.6969 8.9687 12.9448 8.574 13.2995 8.45576L14.0339 8.21097C14.3834 8.09447 14.6667 8.29514 14.6667 8.67714V10C14.6667 10 15.0949 8.61792 15.3334 9.33336C15.5719 10.0488 15.1629 11.3686 15.1629 11.3686C15.073 11.7173 14.705 12 14.323 12H13.6772C13.3032 12 12.9693 11.6924 12.9326 11.3255L12.7342 9.34125Z",
          fill: "#E6101E"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M13.9989 3.87793C13.3181 3.87793 12.7111 4.28213 12.4421 4.89484L12.3081 5.20005L12.9186 5.46804L13.0526 5.16282C13.2161 4.79025 13.585 4.5446 13.9989 4.5446C14.41 4.5446 14.7767 4.78676 14.942 5.15538L15.0785 5.45952L15.6867 5.18669L15.5503 4.88255C15.2785 4.27641 14.675 3.87793 13.9989 3.87793Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M14.0001 6.5C14.7364 6.5 15.3334 6.73637 15.3334 5.99999C15.3334 5.26361 14.7365 4.66665 14.0001 4.66665C13.2637 4.66665 12.6667 5.26361 12.6667 5.99999C12.6667 6.73637 13.2637 6.5 14.0001 6.5Z",
          fill: "#5169E2"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M13.5 6.5C14.2364 6.5 16 5.73639 16 5.00001C16 4.90684 16.0698 4.66665 15.3334 4.66665C14.597 4.66665 14.0001 5.26361 14.0001 5.99999C14.0001 6.73637 12.7636 6.5 13.5 6.5Z",
          fill: "#D34D43"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M14.0001 5.99999C14.0001 6.73637 14.7364 5.99999 14.0001 5.99999C14.0001 5.26361 13.4031 4.66665 12.6668 4.66665C11.9304 4.66665 12 4.89559 12 5C12 5.73638 13.2637 5.99999 14.0001 5.99999Z",
          fill: "#D34D43"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M12 5L13.3334 5.33333L14.0001 4.66665L14.6667 5.33333L16 5.00001L15.4619 6.34532C15.3909 6.52279 15.19 6.66667 15.0064 6.66667H12.9937C12.8131 6.66667 12.6144 6.53589 12.5381 6.34532L12 5ZM14 4C13.6318 4 13.3334 3.70152 13.3334 3.33333C13.3334 2.96514 13.6318 2.66667 14 2.66667C14.3682 2.66667 14.6667 2.96514 14.6667 3.33333C14.6667 3.70152 14.3682 4 14 4Z",
          fill: "#FFD148"
        }
      )
    ]
  }
);
const VpFlagGbNirAsset = forwardRef(FlagGbNirAsset);

export { VpFlagGbNirAsset as default };
